import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-800 text-white border-t border-gray-700">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
          {/* CROCUS Info */}
          <div>
            <div className="flex items-center mb-2">
              <img 
                src="https://i.ibb.co/rRJ3gJzs/crocus-dark.png" 
                alt="CROCUS Logo" 
                className="h-8"
              />
            </div>
            <p className="text-gray-400 text-xs">
              Researching how extreme weather conditions impact the Chicago region and its people.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-2">Links</h3>
            <ul className="space-y-1 text-xs">
              <li>
                <Link 
                  to="/docs"
                  className="text-gray-400 hover:text-white"
                >
                  Documentation
                </Link>
              </li>
              <li>
                <Link 
                  to="/status-report"
                  className="text-gray-400 hover:text-white"
                >
                  Status Report
                </Link>
              </li>
              <li>
                <a 
                  href="https://crocus-urban.org/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white"
                >
                  CROCUS Website
                </a>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-2">Contact</h3>
            <a 
              href="mailto:berkelha@uic.edu"
              className="text-gray-400 hover:text-white text-xs block mb-2"
            >
              berkelha@uic.edu
            </a>
            <p className="text-gray-400 text-xs">
              Questions about the data or interested in collaboration? Contact us.
            </p>
          </div>
        </div>
        
        {/* Bottom */}
        <div className="mt-4 pt-4 border-t border-gray-700 text-center text-xs text-gray-500">
          <p>© {currentYear} CROCUS. Funded by the U.S. Department of Energy's Office of Science.</p>
          <p className="mt-2">
            This portal uses components from the open-source{' '}
            <a 
              href="https://portal.sagecontinuum.org/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 hover:underline"
            >
              Sage Continuum
            </a>
            {' '}project (
            <a 
              href="https://github.com/sagecontinuum/sage-gui" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 hover:underline"
            >
              GitHub
            </a>
            )
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;